import { useUnit } from 'effector-react'
import * as React from 'react'

import {
  $accounts,
  getBonusAccounts,
  accountsMounted,
  $errorAccountsRequest,
} from './model'

export const useBonusAccountsWidget = () => {
  React.useEffect(() => {
    accountsMounted()
  }, [])

  const accounts = useUnit($accounts)
  const errorAccountsRequest = useUnit($errorAccountsRequest)

  const loading = useUnit(getBonusAccounts.pending)

  return {
    accounts,
    loading,
    errorAccountsRequest,
  }
}
